import { format } from 'date-fns/format';
import { parse } from 'date-fns/parse';

interface StatementMailtoParams {
  clientEmail: string;
  clientName: string;
  businessName: string;
  propertyNickname: string;
  endDate: string;
  fileLink: string;
}

export function buildStatementMailtoHref(
  params: StatementMailtoParams,
): string {
  const {
    clientEmail,
    clientName,
    businessName,
    propertyNickname,
    endDate,
    fileLink,
  } = params;

  const date = parse(endDate, 'yyyy-MM-dd', new Date());
  const monthText = format(date, 'MMMM');
  const monthYear = format(date, 'MMMM yyyy');

  const subject = window.encodeURIComponent(
    `${businessName} Statement - ${propertyNickname} - ${monthYear}`,
  );

  const body = window.encodeURIComponent(
    `Dear ${clientName},\n\nPlease find below your ${monthText} statement for ${propertyNickname}.\n\n${fileLink}\n\nKind regards,\n\n${businessName}`,
  );

  return `mailto:${clientEmail}?subject=${subject}&body=${body}`;
}
